import AccountTargetSelector from './AccountTargetSelector'
import TargetAllocationScopeProvider from './TargetAllocationScopeProvider'

const targetAllocationChartModule = {
  AccountTargetSelector,
  TargetAllocationScopeProvider
}

export default targetAllocationChartModule
